import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import useOnEnterPress from '../../../hooks/EnterPress';
import CommentInput from '../../Inputs/CommentInput/CommentInput';
import Tag from '../../../ui_components/Tag/Tag';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import Alert from '../../../ui_components/Alert/Alert';
import AlertType from '../../../ui_components/Alert/AlertType';
import Link from '../../../ui_components/Link/Link';
import TextInput from '../../../ui_components/TextInput/TextInput';
import TextInputType from '../../../ui_components/TextInput/TextInputType';
import MarkDamagedArticleStockButtonProperties from './MarkDamagedArticleStockButtonProperties';
import MarkDamagedArticleStockStore from './MarkDamagedArticleStockButtonStore';
import {useStyles} from './MarkDamagedArticleStockButton.style';

const MarkDamagedArticleStockButton: React.FC<MarkDamagedArticleStockButtonProperties> = ({
                                                                                  entityId,
                                                                                  articleId,
                                                                                  className = '',
                                                                                  onClick = () => {
                                                                                  },
                                                                                  onSave = () => {
                                                                                  },
                                                                              }) => {
    const classes = useStyles();

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const store = new MarkDamagedArticleStockStore(commonContext, entityId, articleId);

    const text = 'Agregar/disminuir artículos dañados';

    const handleOnclick = async () => {
        store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.closeModal();
        onSave();
    }

    const onAmountChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        store.amount = +event.target.value;
    }

    const onCommentChange = (comment: string) => store.comment = comment;

    const onDamagedSave = async () => {
        const saved = await store.save();
        if (saved) {
            store.closeModal();
            onSave();
        }
    }
    useOnEnterPress(onDamagedSave, [store]);

    return <Observer>
        {() => (
            <>
                <Modal fullScreen={false} loading={store.loading} title={text} onClose={onCloseModal} open={store.isModalOpen}>
                    <div className={classes.modal_container}>
                        <div className={classes.hint}>
                            <Tag startIcon={GppMaybeIcon} text={'Para marcar artículos como dañados, coloque un valor positivo. Para repararlos (volver a disponibles), coloque un valor negativo.'}/>
                        </div>
                        <TextInput
                            type={TextInputType.NUMBER}
                            value={store.amount || ''}
                            onChange={onAmountChange}
                            label={'Cantidad'}
                            fullWidth
                            className={classes.input}
                        />
                        <CommentInput
                            lines={3}
                            onChange={onCommentChange}
                            fullWidth
                            value={store.comment}
                            className={classes.input}
                        />
                        {store.success && (
                            <Alert
                                className={classes.alert}
                                text={'Estoque actualizado con éxito'}
                                type={AlertType.SUCCESS}
                            />
                        )}
                        <div className={classes.btn_container}>
                            <Button
                                disabled={!store.enableButton}
                                loading={store.loading} className={classes.save_btn} onClick={onDamagedSave}
                                type={ButtonType.SECONDARY}
                                text={i18n.translate("SAVE")}/>
                        </div>
                    </div>
                </Modal>
                <Link className={className} text={text} onClick={handleOnclick}/>
            </>
        )}
    </Observer>
}

export default MarkDamagedArticleStockButton;
